module.exports = __webpack_public_path__ + "img/理事单位@2x.10df8ac9.png";